/* ===========================================================
   Neu Appliance Outlet — Horizon theme interactions
   Ported from the static neu-outlet site. Product rails are now
   rendered server-side (Liquid), so this only wires behavior.
   Null-safe: every feature guards on element presence so the
   same bundle is safe to load on any template.
   =========================================================== */
(function () {
  'use strict';
  // Guard against the bundle being included more than once (double-registered
  // listeners broke the wishlist toggle: add-then-remove netted zero).
  if (window.__neuInit) return;
  window.__neuInit = true;
  const $  = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const on = (el, ev, fn, opt) => el && el.addEventListener(ev, fn, opt);
  // Reveal everything immediately inside the theme editor / reduced motion / bots.
  const REVEAL_ALL = (window.Shopify && Shopify.designMode) ||
    (navigator && navigator.webdriver) ||
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- star renderer ---------- */
  function starSVG() {
    return '<svg viewBox="0 0 24 24" class="star"><path d="M12 2.5l2.9 6 6.6.9-4.8 4.6 1.2 6.5L12 18.9 6.1 21l1.2-6.5L2.5 9.9l6.6-.9z"/></svg>';
  }
  function fillStars(scope) {
    $$('[data-stars]', scope || document).forEach(el => {
      if (!el.children.length) el.innerHTML = starSVG().repeat(+el.dataset.stars || 5);
    });
  }
  // Expose so client-rendered cards (collection / search / Just Landed index grids) can fill their
  // stars after they're injected — they render after this initial pass, which is why stars were blank.
  window.neuFillStars = fillStars;
  fillStars(document);

  /* ---------- reveal on scroll + stagger promotion ---------- */
  $$('[data-stagger]').forEach(p => {
    [...p.children].forEach((c, i) => {
      c.classList.add('reveal');
      if (!c.style.getPropertyValue('--i')) c.style.setProperty('--i', i % 4);
    });
  });
  const io = new IntersectionObserver((es) => {
    es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
  if (REVEAL_ALL) {
    $$('.reveal').forEach(el => el.classList.add('in'));
  } else {
    $$('.reveal').forEach(el => io.observe(el));
    // failsafe: never leave content stuck hidden
    setTimeout(() => $$('.reveal:not(.in)').forEach(el => el.classList.add('in')), 3000);
  }

  /* ---------- sticky shrink ---------- */
  const shell = $('#stickyShell');
  if (shell) on(window, 'scroll', () => shell.classList.toggle('is-stuck', scrollY > 30), { passive: true });

  /* ---------- lazy add-to-cart hydration (perf: task 86e1zc7z2) ----------
     The grid emits a lightweight NATIVE add-to-cart <form> placeholder + an inert <template> per card
     instead of mounting a Horizon <product-form-component> for all ~180 cards up front. We clone the
     template in (hydrating the real component → AJAX + cart drawer) when a card nears the viewport.
     IO ignores display:none, so the mobile-hidden ATC never hydrates. If a card is somehow tapped before
     hydration, the native placeholder form still adds to cart (posts to /cart/add) — never a dead tap. */
  (function lazyAtc() {
    const wraps = $$('.pcard__atc[data-atc-lazy]');
    if (!wraps.length) return;
    function hydrate(wrap) {
      if (!wrap || wrap.dataset.atcHydrated) return;
      const tpl = wrap.querySelector('template[data-atc-template]');
      if (!tpl) return;
      wrap.dataset.atcHydrated = '1';
      wrap.insertBefore(tpl.content.cloneNode(true), tpl); // inserting connects the component → it upgrades
      const ph = wrap.querySelector('[data-atc-ph]');
      if (ph) ph.remove();
      tpl.remove();
    }
    if (REVEAL_ALL || !('IntersectionObserver' in window)) {
      wraps.forEach(hydrate); // bots / reduced-motion / no-IO: mount everything so nothing depends on scroll
      return;
    }
    const aio = new IntersectionObserver((es) => {
      es.forEach((e) => { if (e.isIntersecting) { hydrate(e.target); aio.unobserve(e.target); } });
    }, { rootMargin: '600px 0px' });
    wraps.forEach((w) => aio.observe(w));
  })();

  /* ---------- mega menu (hover + keyboard operable) ---------- */
  const scrim = $('#megaScrim');
  if (scrim) {
    const items = $$('.nav__item.has-mega');
    const setExp = (item, v) => { const l = item.querySelector('.nav__link'); if (l) l.setAttribute('aria-expanded', v ? 'true' : 'false'); };
    const closeAll = () => { items.forEach(o => { o.classList.remove('open'); setExp(o, false); }); scrim.classList.remove('show'); };
    items.forEach(item => {
      const link = item.querySelector('.nav__link');
      if (link) { link.setAttribute('aria-haspopup', 'true'); link.setAttribute('aria-expanded', 'false'); link.setAttribute('aria-controls', 'mega-' + (item.getAttribute('data-mega') || '')); }
      const open = () => { items.forEach(o => { const isit = o === item; o.classList.toggle('open', isit); setExp(o, isit); }); scrim.classList.add('show'); };
      const close = () => { item.classList.remove('open'); setExp(item, false); if (!$('.nav__item.has-mega.open')) scrim.classList.remove('show'); };
      on(item, 'mouseenter', open);
      on(item, 'mouseleave', close);
      // open on click/Enter (keyboard), not on focus — focus-to-open fights Esc (reopen loop) and pops menus while tabbing through.
      on(link, 'click', (e) => { e.preventDefault(); item.classList.contains('open') ? close() : open(); });
    });
    on(scrim, 'mouseenter', closeAll);
    on(document, 'keydown', (e) => { if (e.key === 'Escape') { const o = $('.nav__item.has-mega.open'); if (o) { closeAll(); const l = o.querySelector('.nav__link'); if (l) l.focus(); } } });
  }

  /* ---------- mobile nav: close the drawer on link / favorites tap ---------- */
  const navToggle = $('#navToggle');
  if (navToggle) {
    $$('.nav__menu a.nav__link, .nav__menu [data-wishlist-open]').forEach(el => {
      on(el, 'click', () => { navToggle.checked = false; });
    });
  }

  /* ---------- search modal ---------- */
  const sm = $('#searchModal'), si = $('#searchInput'), sugg = $('#searchSuggest'),
        suggBox = $('#searchSuggest .searchm__results');
  if (sm) {
    const SUGG = ['Whirlpool Washer', 'LG Refrigerator', 'Samsung Dryer', 'Maytag Range', 'GE Dishwasher', 'Frigidaire Freezer', 'Scratch & Dent Fridge', 'Open Box Microwave'];
    const openSearch = () => { sm.classList.add('open'); sm.setAttribute('aria-hidden', 'false'); setTimeout(() => si && si.focus(), 60); };
    const closeSearch = () => { sm.classList.remove('open'); sm.setAttribute('aria-hidden', 'true'); };
    on($('#searchTrigger'), 'click', openSearch);
    on($('#searchTriggerMobile'), 'click', openSearch);
    on($('#searchClose'), 'click', closeSearch);
    on(sm, 'click', e => { if (e.target === sm) closeSearch(); });
    // Native Shopify predictive search (/search/suggest.json) — products + collections + queries.
    let searchTimer;
    // /search/suggest.json returns price as a DOLLAR string (e.g. "722.00"), not cents — parse, don't divide by 100. (QC 2026-06-19: fixes $722 dryer rendering as $7.22.)
    const money = (dollars) => '$' + Number(dollars).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    on(si, 'input', () => {
      const q = si.value.trim();
      clearTimeout(searchTimer);
      if (!q) { if (sugg) sugg.hidden = true; return; }
      searchTimer = setTimeout(() => {
        // task 86e25fb67: hide out-of-stock products from predictive search suggestions.
        const url = '/search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,query&resources[limit]=6&resources[options][unavailable_products]=hide';
        fetch(url, { headers: { 'Accept': 'application/json' } })
          .then(r => r.json())
          .then(d => {
            const res = (d.resources && d.resources.results) || {};
            const products = (res.products || []).filter(function (p) { return p.available !== false; }), collections = res.collections || [], queries = res.queries || [];
            let html = '';
            products.forEach(p => {
              const img = (p.featured_image && p.featured_image.url) || (p.image) || '';
              const price = p.price != null ? ' <span class="searchm__price">' + money(p.price) + '</span>' : '';
              html += '<a class="searchm__hit" href="' + p.url + '">' + (img ? '<img src="' + img + '&width=80" alt="" loading="lazy">' : '') + '<span>' + p.title + price + '</span></a>';
            });
            collections.forEach(c => { html += '<a class="searchm__hit searchm__hit--col" href="' + c.url + '"><svg class="ic ic--16"><use href="#i-arrow"/></svg><span>' + c.title + '</span></a>'; });
            queries.forEach(qq => { html += '<a href="/search?q=' + encodeURIComponent(qq.text) + '&type=product&filter.v.availability=1"><svg class="ic ic--16"><use href="#i-search"/></svg>' + qq.text + '</a>'; });
            if (!html) html = '<a href="/search?q=' + encodeURIComponent(q) + '&type=product&filter.v.availability=1"><svg class="ic ic--16"><use href="#i-search"/></svg>Search for &ldquo;' + q + '&rdquo;</a>';
            if (suggBox) suggBox.innerHTML = html;
            if (sugg) sugg.hidden = false;
          })
          .catch(() => { if (sugg) sugg.hidden = true; });
      }, 200);
    });
    const form = sm.querySelector('form');
    on(form, 'submit', e => { if (!si || !si.value.trim()) return; });
    on(si, 'keydown', e => { if (e.key === 'Enter' && si.value.trim()) { e.preventDefault(); window.location.href = '/search?q=' + encodeURIComponent(si.value.trim()) + '&type=product&filter.v.availability=1'; } });
    window.neuCloseSearch = closeSearch;
  }

  /* ---------- hero slider ---------- */
  const cards = $$('#heroCards .hcard'), dots = $$('#heroDots button');
  if (cards.length) {
    let hi = Math.min(1, cards.length - 1), htimer;
    // a11y: honor reduced-motion (no auto-advance) and expose active state to screen readers.
    const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const heroGo = (n) => {
      hi = (n + cards.length) % cards.length;
      cards.forEach((c, i) => c.classList.toggle('is-active', i === hi));
      dots.forEach((d, i) => { d.classList.toggle('is-active', i === hi); d.setAttribute('aria-current', i === hi ? 'true' : 'false'); });
    };
    const reset = () => { clearInterval(htimer); if (!reduceMotion) htimer = setInterval(() => heroGo(hi + 1), 4500); };
    dots.forEach((d, i) => on(d, 'click', () => { heroGo(i); reset(); }));
    heroGo(hi); reset();
  }

  /* ---------- product rail tabs (server-rendered cards) ---------- */
  // "Just Landed": tabs filter by data-cond. "All" shows everything.
  $$('[data-railtabs]').forEach(tabs => {
    const railId = tabs.getAttribute('data-railtabs');
    const rail = document.getElementById(railId);
    if (!rail) return;
    const mode = tabs.getAttribute('data-tabmode') || 'cond'; // 'cond' or 'cat'
    const apply = (val) => {
      $$('.pcard', rail).forEach(card => {
        const key = mode === 'cat' ? (card.dataset.cat || '') : (card.dataset.cond || '');
        card.style.display = (val === 'all' || key === val) ? '' : 'none';
      });
    };
    // Dynamic tabs (task 86e2702jy): only show a condition tab if the rail actually has products for it,
    // so a shopper can never land on an empty tab. Reflects the products present, like the collection filters.
    if (mode === 'cond') {
      const present = {};
      $$('.pcard', rail).forEach(c => { const k = c.dataset.cond || ''; if (k) present[k] = 1; });
      $$('button', tabs).forEach(b => { const t = b.dataset.tab; if (t !== 'all' && !present[t]) b.style.display = 'none'; });
    }
    on(tabs, 'click', e => {
      const b = e.target.closest('button'); if (!b) return;
      $$('button', tabs).forEach(x => x.classList.toggle('is-active', x === b));
      apply(b.dataset.tab);
    });
    let active = $('button.is-active', tabs);
    if (!active || active.style.display === 'none') active = $$('button', tabs).filter(b => b.style.display !== 'none')[0];
    if (active) { $$('button', tabs).forEach(x => x.classList.toggle('is-active', x === active)); apply(active.dataset.tab); }
  });

  /* ---------- generic tab switcher: [data-tabset] wraps buttons[data-tab]; panels carry data-pane ---------- */
  $$('[data-tabset]').forEach(set => {
    on(set, 'click', e => {
      const b = e.target.closest('[data-tab]'); if (!b) return;
      const key = b.dataset.tab;
      $$('[data-tab]', set).forEach(x => x.classList.toggle('is-active', x === b));
      const scope = document.querySelector(set.dataset.tabset ? `#${set.dataset.tabset}` : 'body') || document;
      $$('[data-pane]', scope).forEach(p => { p.hidden = !(p.dataset.pane === key || key === 'all'); });
    });
  });

  /* ---------- wishlist (localStorage-backed) ---------- */
  const WL_KEY = 'neu_wishlist';
  const wlRead = () => { try { return JSON.parse(localStorage.getItem(WL_KEY)) || []; } catch (e) { return []; } };
  const wlWrite = (items) => { try { localStorage.setItem(WL_KEY, JSON.stringify(items)); } catch (e) {} wlSync(); };
  const wlRemove = (url) => wlWrite(wlRead().filter(i => i.url !== url));
  const wlToggle = (item) => {
    if (!item || !item.url) return false;
    const items = wlRead();
    const i = items.findIndex(x => x.url === item.url);
    if (i >= 0) { items.splice(i, 1); wlWrite(items); return false; }
    items.unshift(item); wlWrite(items); return true;
  };
  const wlItemFromCard = (card) => {
    const link = card.querySelector('a[href]');
    return {
      url: card.dataset.href || (link ? link.getAttribute('href') : '') || '',
      title: card.dataset.title || '',
      img: card.dataset.img || '',
      brand: card.dataset.brand || '',
      price: card.dataset.price || '',
      was: card.dataset.was || '',
      badge: card.dataset.badge || ''
    };
  };
  const wlEsc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const wlRender = () => {
    const list = $('#neu-wishlist-list'); if (!list) return;
    const items = wlRead();
    if (!items.length) {
      list.innerHTML = '<p class="neu-wl__empty">Your wishlist is empty.<br>Tap the heart on any product to save it here.</p>';
      return;
    }
    list.innerHTML = items.map(i => `
      <div class="neu-wl__item" data-wl-url="${wlEsc(i.url)}">
        <a class="neu-wl__media" href="${wlEsc(i.url)}">${i.img ? `<img src="${wlEsc(i.img)}" alt="" loading="lazy">` : ''}</a>
        <div class="neu-wl__info">
          ${i.brand ? `<span class="neu-wl__brand">${wlEsc(i.brand)}</span>` : ''}
          <a class="neu-wl__title" href="${wlEsc(i.url)}">${wlEsc(i.title)}</a>
          <div class="neu-wl__price"><b>${wlEsc(i.price)}</b>${i.was ? `<s>${wlEsc(i.was)}</s>` : ''}</div>
          <div class="neu-wl__rowbtns"><a class="btn btn--navy" href="${wlEsc(i.url)}">Shop Now</a><button type="button" class="neu-wl__remove" data-wl-remove="${wlEsc(i.url)}" aria-label="Remove">Remove</button></div>
        </div>
      </div>`).join('');
  };
  const wlSync = () => {
    const items = wlRead();
    const urls = new Set(items.map(i => i.url));
    $$('[data-wishlist-count]').forEach(el => { el.textContent = items.length; el.hidden = items.length === 0; });
    $$('.pcard').forEach(card => {
      const fav = card.querySelector('.pcard__fav');
      if (fav) fav.classList.toggle('on', urls.has(wlItemFromCard(card).url));
    });
    const d = $('#neu-wishlist'); if (d && d.classList.contains('open')) wlRender();
  };
  const wlOpen = () => { const d = $('#neu-wishlist'); if (!d) return; wlRender(); d.classList.add('open'); d.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; };
  const wlClose = () => { const d = $('#neu-wishlist'); if (!d) return; d.classList.remove('open'); d.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; };
  window.neuWishlistOpen = wlOpen;

  on(document, 'click', e => {
    const fav = e.target.closest('.pcard__fav');
    if (fav) { e.preventDefault(); const card = fav.closest('.pcard'); if (card) { const added = wlToggle(wlItemFromCard(card)); fav.classList.toggle('on', added); if (added) wlOpen(); /* QC 2026-06-19: open the wishlist drawer when a product is favorited */ } return; }
    const qvFav = e.target.closest('.qv__fav');
    if (qvFav) { e.preventDefault(); const qvEl = $('#qvModal'); const item = qvEl && qvEl._neuItem; if (item) { const added = wlToggle(item); qvFav.classList.toggle('on', added); if (added) wlOpen(); } return; }
    if (e.target.closest('[data-wishlist-open]')) { e.preventDefault(); wlOpen(); return; }
    if (e.target.closest('[data-wishlist-close]')) { e.preventDefault(); wlClose(); return; }
    const rm = e.target.closest('[data-wl-remove]');
    if (rm) { e.preventDefault(); wlRemove(rm.getAttribute('data-wl-remove')); return; }
    const d = $('#neu-wishlist');
    if (d && d.classList.contains('open') && e.target === d) wlClose();
  });
  on(document, 'keydown', e => { if (e.key === 'Escape') wlClose(); });
  wlSync();

  /* ---------- quick view ---------- */
  const qv = $('#qvModal');
  if (qv) {
    const setTxt = (id, v) => { const el = $(id); if (el) el.textContent = v || ''; };
    on(document, 'click', e => {
      const q = e.target.closest('[data-quick]'); if (!q) return;
      e.preventDefault();
      const card = q.closest('.pcard'); if (!card) return;
      const img = $('#qvImg'); if (img) { img.src = card.dataset.img || ''; img.alt = card.dataset.brand || ''; }
      setTxt('#qvBrand', card.dataset.brand);
      setTxt('#qvTitle', card.dataset.title);
      setTxt('#qvCount', card.dataset.badge);
      setTxt('#qvPrice', card.dataset.price);
      setTxt('#qvWas', card.dataset.was);
      setTxt('#qvSave', card.dataset.save);
      const shop = $('#qvShop'); if (shop) shop.href = card.dataset.href || '#';
      // hand the quick-view its product so the wishlist heart can save it
      qv._neuItem = wlItemFromCard(card);
      const qvFav = qv.querySelector('.qv__fav');
      if (qvFav) qvFav.classList.toggle('on', wlRead().some(i => i.url === qv._neuItem.url));
      qv.classList.add('open'); qv.setAttribute('aria-hidden', 'false');
      setTimeout(() => { const c = $('#qvClose'); if (c) c.focus(); }, 60);
    });
    const closeQv = () => { qv.classList.remove('open'); qv.setAttribute('aria-hidden', 'true'); };
    on($('#qvClose'), 'click', closeQv);
    on(qv, 'click', e => { if (e.target === qv) closeQv(); });
    window.neuCloseQv = closeQv;
  }

  /* ---------- marquees: duplicate track content for a seamless loop ---------- */
  $$('.marquee__track').forEach(track => {
    const originals = [...track.children];
    if (!originals.length) return;
    // Clones are visual-only duplicates for the seamless loop — hide them from screen readers /
    // keyboard so each review/brand is announced and tabbed once, not 2-3x.
    const dupe = (n) => { const c = n.cloneNode(true); c.setAttribute('aria-hidden', 'true'); c.querySelectorAll('a,button,[tabindex]').forEach(f => f.setAttribute('tabindex', '-1')); return c; };
    let guard = 0;
    const vw = window.innerWidth || 1280;
    while (track.scrollWidth < vw && guard < 30) { originals.forEach(n => track.appendChild(dupe(n))); guard++; }
    const set = [...track.children];
    set.forEach(n => track.appendChild(dupe(n)));
  });
  fillStars(document); // re-fill stars inside cloned marquee cards

  /* ---------- zip checker ---------- */
  const zipForm = $('#zipForm');
  if (zipForm) {
    // Per-ZIP local-delivery rate (USD) — kept IDENTICAL to RATE_TABLE in
    // snippets/neu-pickup-delivery.liquid + sections/neu-cart-delivery.liquid + the delivery Function.
    const RATE_TABLE = {'73301':45,'78701':45,'78702':45,'78703':45,'78704':45,'78705':45,'78712':45,'78721':45,'78722':45,'78723':45,'78724':45,'78727':45,'78728':45,'78729':45,'78730':45,'78731':45,'78735':45,'78741':45,'78742':45,'78746':45,'78750':45,'78751':45,'78752':45,'78753':45,'78754':45,'78756':45,'78757':45,'78758':45,'78759':45,'78613':75,'78617':75,'78653':75,'78660':75,'78664':75,'78665':75,'78681':75,'78717':75,'78719':75,'78725':75,'78726':75,'78744':75,'78745':75,'78747':75,'78748':75,'78749':75,'76530':99,'78610':99,'78628':99,'78634':99,'78641':99,'78652':99,'78732':99,'78733':99,'78734':99,'78736':99,'78737':99,'78739':99,'76574':125,'78612':125,'78615':125,'78616':125,'78619':125,'78620':125,'78621':125,'78626':125,'78633':125,'78640':125,'78642':125,'78645':125,'78738':125,'76527':149,'76537':149,'78602':149,'78605':149,'78644':149,'78654':149,'78666':149,'78669':149,'78676':149};
    const showResult = (r, text, color) => { r.textContent = text; r.style.color = color; r.removeAttribute('hidden'); };
    on(zipForm, 'submit', (e) => {
      e.preventDefault();
      const input = $('#zipInput'), r = $('#zipResult');
      if (!input || !r) return;
      const z = input.value.trim();
      if (!/^\d{5}$/.test(z)) { showResult(r, 'Please enter a valid 5-digit ZIP code.', 'var(--gold)'); return; }
      if (Object.prototype.hasOwnProperty.call(RATE_TABLE, z)) {
        showResult(r, `✓ We deliver to ${z}! Delivery Price: $${RATE_TABLE[z]}`, 'var(--c-open)');
      } else {
        showResult(r, `Sorry — ${z} is outside our delivery area right now.`, 'var(--red)');
      }
    });
  }

  /* ---------- condition card learn-more modal ---------- */
  const cm = $('#condModal');
  if (cm) {
    const openCond = () => { cm.classList.add('open'); cm.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; setTimeout(() => { const c = $('#condmClose'); if (c) c.focus(); }, 60); };
    const closeCond = () => { cm.classList.remove('open'); cm.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; };
    $$('.condcard__more').forEach(btn => on(btn, 'click', () => {
      const d = btn.dataset;
      const panel = cm.querySelector('.condm__panel'); if (panel) panel.style.setProperty('--cm-c', d.c || 'var(--c-scratch)');
      const tag = $('#condmTag'); if (tag && d.tag) { tag.src = d.tag; tag.alt = d.title || ''; }
      const set = (id, v) => { const el = $(id); if (el) el.textContent = v || ''; };
      set('#condmTitle', d.title); set('#condmBody', d.body); set('#condmKicker', d.kicker); set('#condmCtaText', d.cta);
      const cta = $('#condmCta'); if (cta) cta.href = d.href || '#';
      openCond();
    }));
    on($('#condmClose'), 'click', closeCond);
    on(cm, 'click', e => { if (e.target === cm) closeCond(); });
    window.neuCloseCond = closeCond;
  }

  /* ---------- esc closes overlays ---------- */
  on(window, 'keydown', e => {
    if (e.key !== 'Escape') return;
    [window.neuCloseSearch, window.neuCloseQv, window.neuCloseCond].forEach(fn => { if (typeof fn === 'function') fn(); });
    if (window.neuCloseReviews) window.neuCloseReviews();
  });

  /* ---------- Neu Link review widget (api.neulink.io) ---------- */
  (function neuLinkWidget() {
    const btn = $('#neu-rw-btn'), overlay = $('#neu-rw-overlay'), drawer = $('#neu-rw-drawer'),
          closeBtn = $('#neu-rw-close-btn'), list = $('#neu-rw-list');
    if (!btn || !drawer) return;
    let loaded = false;
    const open = () => { drawer.classList.add('open'); overlay && overlay.classList.add('open'); document.body.style.overflow = 'hidden'; if (!loaded) fetchReviews(); };
    const close = () => { drawer.classList.remove('open'); overlay && overlay.classList.remove('open'); document.body.style.overflow = ''; };
    on(btn, 'click', open);
    // QC 2026-06-19 (issue-17): any [data-reviews-open] trigger (e.g. the "Read all reviews" button) opens the on-site reviews drawer instead of leaving for Google.
    document.querySelectorAll('[data-reviews-open]').forEach(function (el) { on(el, 'click', function (e) { e.preventDefault(); open(); }); });
    on(overlay, 'click', close);
    on(closeBtn, 'click', close);
    window.neuCloseReviews = close;
    const esc = s => (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    function timeAgo(d) {
      const t = Math.floor((Date.now() - new Date(d)) / 1000);
      if (t < 60) return 'just now'; if (t < 3600) return Math.floor(t / 60) + 'm ago'; if (t < 86400) return Math.floor(t / 3600) + 'h ago';
      const dy = Math.floor(t / 86400); if (dy < 30) return dy + (dy === 1 ? ' day' : ' days') + ' ago';
      const mo = Math.floor(dy / 30); if (mo < 12) return mo + (mo === 1 ? ' month' : ' months') + ' ago';
      const yr = Math.floor(mo / 12); return yr + (yr === 1 ? ' year' : ' years') + ' ago';
    }
    const gLogoSm = '<svg class="neu-rw-card-g-icon" width="18" height="18" viewBox="0 0 48 48"><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/></svg>';
    const verified = '<span class="neu-rw-verified"><svg width="9" height="9" viewBox="0 0 10 10" fill="none"><path d="M2 5l2 2 4-4" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
    function renderCard(r) {
      const name = esc(r.first_name) + (r.last_name_initial ? ' ' + esc(r.last_name_initial) + '.' : '');
      const initials = (r.first_name || '?').charAt(0).toUpperCase() + (r.last_name_initial ? r.last_name_initial.charAt(0).toUpperCase() : '');
      const avatar = r.reviewer_photo ? `<img class="neu-rw-avatar" src="${esc(r.reviewer_photo)}" alt="${esc(name)}" loading="lazy">` : `<div class="neu-rw-avatar-initials">${esc(initials)}</div>`;
      const loc = (r.city || r.state) ? `<div class="neu-rw-card-location">&#128205; ${esc(r.city)}${r.city && r.state ? ', ' : ''}${esc(r.state)}</div>` : '';
      const tags = (r.review_tags && r.review_tags.length) ? `<div class="neu-rw-card-tags">${r.review_tags.map(t => `<span class="neu-rw-tag">${esc(t)}</span>`).join('')}</div>` : '';
      const photo = r.picture_url ? `<img class="neu-rw-card-photo" src="${esc(r.picture_url)}" alt="${esc(r.category || 'Appliance')}" loading="lazy">` : '';
      return `<div class="neu-rw-card"><div class="neu-rw-card-top">${avatar}<div class="neu-rw-card-meta"><div class="neu-rw-card-name">${name}${verified}</div>${loc}<div class="neu-rw-card-date">${timeAgo(r.date_submitted)}</div></div>${gLogoSm}</div><div class="neu-rw-card-stars">★★★★★</div><div class="neu-rw-card-text">${esc(r.review_text)}</div>${tags}${photo}</div>`;
    }
    function fetchReviews() {
      loaded = true;
      fetch('https://api.neulink.io/api/review-submissions?per_page=100&page=1', { headers: { 'Accept': 'application/json' } })
        .then(r => r.json())
        .then(data => {
          const reviews = data.data || [];
          const total = (data.meta && data.meta.total) || reviews.length;
          const t1 = $('#neu-rw-total'), t2 = $('#neu-rw-drawer-total');
          if (t1) t1.textContent = total.toLocaleString();
          if (t2) t2.textContent = total.toLocaleString();
          if (list) list.innerHTML = reviews.length ? reviews.map(renderCard).join('') : '<div class="neu-rw-loading">No reviews yet.</div>';
        })
        .catch(() => { if (list) list.innerHTML = '<div class="neu-rw-loading">Could not load reviews. Please try again later.</div>'; });
    }
    fetch('https://api.neulink.io/api/review-submissions?per_page=1&page=1', { headers: { 'Accept': 'application/json' } })
      .then(r => r.json()).then(d => {
        const t = (d.meta && d.meta.total) || 0;
        if (t) { const t1 = $('#neu-rw-total'), t2 = $('#neu-rw-drawer-total'); if (t1) t1.textContent = t.toLocaleString(); if (t2) t2.textContent = t.toLocaleString(); }
      }).catch(() => {});
  })();

  /* ---------- PDP: image lightbox (blemish zoom) + sticky mobile add-to-cart ---------- */
  (function () {
    const main = document.getElementById('pdpMain');
    if (main) {
      const openLightbox = () => {
        let src = main.src;
        if (/[?&]width=\d+/.test(src)) src = src.replace(/width=\d+/, 'width=1600');
        else if (main.getAttribute('data-zoom')) src = main.getAttribute('data-zoom');
        const lb = document.createElement('div');
        lb.className = 'neu-lightbox';
        lb.innerHTML = '<button class="neu-lightbox__close" aria-label="Close">✕</button><img alt="">';
        lb.querySelector('img').src = src;
        document.body.appendChild(lb);
        document.body.style.overflow = 'hidden';
        requestAnimationFrame(() => lb.classList.add('is-open'));
        const onKey = (e) => { if (e.key === 'Escape') close(); };
        const close = () => { lb.classList.remove('is-open'); document.body.style.overflow = ''; document.removeEventListener('keydown', onKey); setTimeout(() => lb.remove(), 200); };
        lb.addEventListener('click', (e) => { if (e.target === lb || e.target.closest('.neu-lightbox__close')) close(); });
        document.addEventListener('keydown', onKey);
      };
      on(main, 'click', openLightbox);
      const zoomBtn = document.querySelector('[data-pdp-zoom]');
      if (zoomBtn) on(zoomBtn, 'click', (e) => { e.stopPropagation(); openLightbox(); });
    }

    const sticky = document.querySelector('[data-pdp-sticky]');
    const realAdd = document.querySelector('.pdp__addcart');
    if (sticky && realAdd && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        const vis = entries[0].isIntersecting;
        sticky.classList.toggle('is-visible', !vis);
        sticky.setAttribute('aria-hidden', vis ? 'true' : 'false');
      }, { rootMargin: '0px 0px -40px 0px' });
      io.observe(realAdd);
      const stickyAdd = sticky.querySelector('[data-pdp-sticky-add]');
      if (stickyAdd) on(stickyAdd, 'click', () => { realAdd.click(); });
    }
  })();
})();
